export function getLabelFromOptions(
  value: string | number,
  options: { value: string | number; label: string }[]
): string {
  return options.find(opt => opt.value === value)?.label || "";
}
